// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__iUsaV","description":"PatientConsentPreview_description__3Kf6O"};